/**
 * @file: Overdue.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 业务数据管理中心-过期管理
 */
import request from '@/utils/request'

/**
 * 小程序-获取未处理的过期/临期食品详情（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function appletNotoverdueDetailGet(data) {
  return request({
    type: 'biz',
    url: 'applet/notoverdue/detail/get',
    method: 'post',
    data
  })
}

/**
 * 小程序-获取未处理的过期/临期食品列表（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function appletNotoverdueListGet(data) {
  return request({
    type: 'biz',
    url: 'applet/notoverdue/list/get',
    method: 'post',
    data
  })
}

/**
 * 小程序-获取已过期食品详情（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function appletOverdueDetailGet(data) {
  return request({
    type: 'biz',
    url: 'applet/overdue/detail/get',
    method: 'post',
    data
  })
}

/**
 * 小程序-获取已过期食品列表（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function appletOverdueListGet(data) {
  return request({
    type: 'biz',
    url: 'applet/overdue/list/get',
    method: 'post',
    data
  })
}

/**
 * 已处理详情查看-获取信息（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcOverdueGoodsHandleGet(data) {
  return request({
    type: 'biz',
    url: 'pc/overdue/goods/handle/get',
    method: 'post',
    data
  })
}

/**
 * 过期食品处理（ndj）（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcOverdueHandleAdd(data) {
  return request({
    type: 'biz',
    url: 'pc/overdue/handle/add',
    method: 'post',
    data
  })
}

/**
 * 分页获取过期食品列表（ndj）（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcOverdueListGet(data) {
  return request({
    type: 'biz',
    url: 'pc/overdue/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Overdue.js